exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".posicao {\n  display: inline-block;\n  margin: 2px;\n  text-align: center;\n  border: 1px solid #C7C3C3;\n  border-radius: 5px;\n  opacity: 1; }\n\n.posicao:hover {\n  cursor: pointer; }\n\n.conteiner-totais {\n  font-family: 'Poppins', sans-serif;\n  font-size: 14px;\n  background: #FFFFFF;\n  border: 1px solid #C7C3C3;\n  border-radius: 5px;\n  opacity: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/grafico-componente-dialog/grafico-componente-dialog.component.scss
// module id = ../../../../../src/app/grafico-componente-dialog/grafico-componente-dialog.component.scss
// module chunks = main